import { formatCurrency } from "./utils";

export const Currency = ({ amount }: { amount: number }) => {
    return <span>{formatCurrency(amount)}</span>;
};
